import React, { useId } from 'react';

/**
 * Gold trophy — faceted trapezoid cup, angular handles, square plinth (shared: Trophy button + Done pills).
 * @param {'gradient' | 'white'} [variant='gradient'] — gradient for profile UI; white mono for side nav (`currentColor`).
 */
export default function AchievementTrophyIcon({ className, variant = 'gradient' }) {
  const uid = useId().replace(/:/g, '');

  if (variant === 'white') {
    return (
      <svg
        className={className}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        <line
          x1="2"
          y1="21"
          x2="22"
          y2="21"
          stroke="currentColor"
          strokeOpacity="0.45"
          strokeWidth="1.25"
          strokeLinecap="butt"
        />
        <rect x="4" y="18.2" width="16" height="2.6" fill="currentColor" fillOpacity="0.9" />
        <rect x="7" y="16.55" width="10" height="1.95" fill="currentColor" fillOpacity="0.88" />
        <rect x="10.5" y="12.5" width="3" height="4.05" fill="currentColor" fillOpacity="0.95" />
        <path
          d="M3 5.5L3 11.5h2l0.5 -4.5 1.5 -0.8L7 5.5H3z"
          fill="currentColor"
          fillOpacity="0.86"
        />
        <path
          d="M21 5.5L21 11.5h-2l-0.5 -4.5 -1.5 -0.8L17 5.5H21z"
          fill="currentColor"
          fillOpacity="0.9"
        />
        <path d="M7 6.2h10l-1.1 6.3H8.1L7 6.2z" fill="currentColor" />
        <rect x="6.85" y="4.85" width="10.3" height="1.35" fill="currentColor" fillOpacity="0.94" />
        <line
          x1="8.15"
          y1="6.9"
          x2="8.15"
          y2="11.7"
          stroke="currentColor"
          strokeOpacity="0.35"
          strokeWidth="1"
          strokeLinecap="butt"
        />
      </svg>
    );
  }

  const gLeft = `achievement-trophy-grad-l-${uid}`;
  const gMid = `achievement-trophy-grad-m-${uid}`;
  const gRight = `achievement-trophy-grad-r-${uid}`;
  const gRim = `achievement-trophy-rim-${uid}`;

  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <defs>
        <linearGradient id={gLeft} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#fde68a" />
          <stop offset="55%" stopColor="#d97706" />
          <stop offset="100%" stopColor="#78350f" />
        </linearGradient>
        <linearGradient id={gMid} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#fff7c2" />
          <stop offset="35%" stopColor="#fbbf24" />
          <stop offset="100%" stopColor="#b45309" />
        </linearGradient>
        <linearGradient id={gRight} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#fcd34d" />
          <stop offset="50%" stopColor="#ea580c" />
          <stop offset="100%" stopColor="#7c2d12" />
        </linearGradient>
        <linearGradient id={gRim} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#fffef0" />
          <stop offset="100%" stopColor="#fde047" />
        </linearGradient>
      </defs>
      <line
        x1="2"
        y1="21"
        x2="22"
        y2="21"
        stroke="currentColor"
        strokeOpacity="0.45"
        strokeWidth="1.25"
        strokeLinecap="butt"
      />
      <rect x="4" y="18.2" width="16" height="2.6" fill={`url(#${gRight})`} />
      <rect x="7" y="16.55" width="10" height="1.95" fill={`url(#${gMid})`} />
      <rect x="10.5" y="12.5" width="3" height="4.05" fill={`url(#${gMid})`} />
      <path d="M3 5.5L3 11.5h2l0.5 -4.5 1.5 -0.8L7 5.5H3z" fill={`url(#${gLeft})`} />
      <path d="M21 5.5L21 11.5h-2l-0.5 -4.5 -1.5 -0.8L17 5.5H21z" fill={`url(#${gRight})`} />
      <path d="M7 6.2h10l-1.1 6.3H8.1L7 6.2z" fill={`url(#${gMid})`} />
      <rect x="6.85" y="4.85" width="10.3" height="1.35" fill={`url(#${gRim})`} />
      <line x1="8.15" y1="6.9" x2="8.15" y2="11.7" stroke="#fffbeb" strokeOpacity="0.4" strokeWidth="1" strokeLinecap="butt" />
    </svg>
  );
}
